import * as yup from 'yup';

export const inventoryFormSchema = (t: any): yup.AnyObjectSchema =>
  yup.object().shape({
    conditionedStocks: yup.array().of(
      yup.object().shape({
        inventoryConditioningQuantity: yup.lazy(inventoryConditioningQuantity => {
          return yup
            .number()
            .transform(value => (isNaN(value) ? undefined : value))
            .required(t('validation.inventoryConditioningQuantity.required'))
            .typeError(t('validation.inventoryConditioningQuantity.invalid'));
        }),
        inventoryWeight: yup.lazy(inventoryWeight => {
          return yup
            .number()
            .transform(value => (isNaN(value) ? undefined : value))
            .required(t('validation.inventoryWeight.required'))
            .typeError(t('validation.inventoryWeight.invalid'));
        }),
        inventoryAverageBallWeight: yup.lazy(inventoryConditioningAverage => {
          return yup
            .number()
            .transform(value => (isNaN(value) ? undefined : value))
            .test(
              'inventoryAverageBallWeightValidation',
              t('validation.inventoryConditioningAverage.required'),
              (value, context) => {
                return (!context.parent.isMaterialBulk && value && value > 0) || context.parent.isMaterialBulk;
              },
            );
        }),
      }),
    ),
  });
